import { createSlice } from "@reduxjs/toolkit";

const initialSubjectTracking = {
  solvedQuestionNumber: 0,
  date: "",
  explanation: "",
  courses: [],
  completedSubjectCount: 0,
  totalSubjectCount: 0
};

const initialSubjectTrackingState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  courses: [],
  courseSubjects: [],
  subjectOutcomes: [],
  subjectTracking: initialSubjectTracking
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const dailySubjectTrackingSlice = createSlice({
  name: "dailySubjectTracking",
  initialState: initialSubjectTrackingState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },    
    // getSubjectProgress
    subjectProgressFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.completedSubjectCount = entity && entity.completedCount;
      state.totalSubjectCount = entity && entity.totalCount;
    },
    // getCourses
    coursesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.courses = entities;
    },
    // getCourseSubjects
    courseSubjectsFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.courseSubjects = action.payload.entities;
    },
    // getSubjectOutcomes
    subjectOutcomesFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.subjectOutcomes = action.payload.entities;
    },
    //getSubjectTracking
    subjectTrackingFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.subjectTracking = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanDailySubjectTrackingState
    dailySubjectTrackingStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];      
      state.courseSubjects = [];
      state.subjectOutcomes = [];
      state.totalSubjectCount = 0;
      state.completedSubjectCount = 0;
      state.subjectTracking = initialSubjectTracking;
    }
  }
});